const routeSelector = state => state.kea.router.location

export default routeSelector
